<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    class="icon-checkmark"
    :class="`icon-checkmark--color-${color}`"
  >
    <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
  </svg>
</template>

<script>
  export default {
    name: 'IconCheckMark',
    props: {
      color: {
        type: String,
        default: 'black',
        validator: function (value) {
          return ['black', 'white'].includes(value);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-checkmark {
    &--color-white {
      fill: white;
    }
    &--color-black {
      fill: black;
    }
  }
</style>
